const _campaignEnabled = true; // テスト中: false　正規リリース時: true

const _campaignKey = 'campaign-pop';
const _campaignPOP = document.querySelector('#CampaignPop');
const _campaignExpiry = 7; // 保持日数

// 有効期限付きで保存
const _campaignSetWithExpiry = (key, value, days) => {
    const item = {
        value: value,
        expiry: Date.now() + days * 24 * 60 * 60 * 1000
    };
    localStorage.setItem(key, JSON.stringify(item));
};

// 有効期限チェック付きで取得（期限切れはnull）
const _campaignGetWithExpiry = (key) => {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) return null;
    try {
        const item = JSON.parse(itemStr);
        if (Date.now() > item.expiry) {
            localStorage.removeItem(key);
            return null;
        }
        return item.value;
    } catch(e) {
        // 古い形式のデータはリセット
        localStorage.removeItem(key);
        return null;
    }
};

const _campaignIsOn = (key) => _campaignGetWithExpiry(key) !== 'off';

const _campaignToggleState = (key) => {
    const current = _campaignGetWithExpiry(key);
    const newValue = (current === 'off') ? 'on' : 'off';
    _campaignSetWithExpiry(key, newValue, _campaignExpiry);
    return newValue === 'on';
};

// URLパラメータ ?preview-popup=on でスタッフ用プレビュー強制表示
const _campaignPreview = new URLSearchParams(window.location.search).get('preview-popup') === 'on';

// テスト中かつプレビューでない場合はcookieをoff強制登録
if (!_campaignEnabled && !_campaignPreview) {
    _campaignSetWithExpiry(_campaignKey, 'off', _campaignExpiry);
}

// 初期表示（1秒後にフェードイン）
if (_campaignIsOn(_campaignKey) || _campaignPreview) {
    setTimeout(() => {
        _campaignPOP.classList.add('is-active');
    }, 1000);
} else {
    _campaignPOP.classList.remove('is-active');
}

// 閉じるボタン・オーバーレイのクリックイベント
document.querySelectorAll('.js-module-cookie-popup').forEach((e) => {
    e.addEventListener('click', () => {
        const nowOn = _campaignToggleState(_campaignKey);
        if (nowOn) {
            _campaignPOP.classList.add('is-active');
        } else {
            _campaignPOP.classList.remove('is-active');
        }
    });
});
